import React from 'react';
import { ReactComponent as BlueIcon } from './support-blue.svg';
import { ReactComponent as WhiteIcon } from './support-white.svg';
import { BaseIconProps } from '../BaseIcon';

type SupportIconProps = BaseIconProps;

export const SupportIcon: React.FC<SupportIconProps> = ({
  iconColor,
  width,
  height,
}) =>
  iconColor === 'white' ? (
    <WhiteIcon width={width} height={height} />
  ) : (
    <BlueIcon width={width} height={height} />
  );
